import { useDispatch, useSelector } from "react-redux";
import { Avatar, Grid, Group, Indicator, Tooltip, createStyles, Image, Modal, Button, Text, TextInput, Alert, Switch} from '@mantine/core';
import { handleonlinebar } from "../../slice/mainslice";

import { Checkbox, DeviceComputerCamera, UserOff, UserPlus, CircleX,  MailForward } from 'tabler-icons-react';
import idaustrialogo from '../../images/idaustriaw.png'
import intl from "react-intl-universal";
import { useEffect, useState } from "react";
import AddUserToMeetingDrn from "./AddUserToMeetingDrn";


const useStyles = createStyles((theme) => ({
    padtop10: {
      paddingTop: `10px`,
    },
    overdiv: {
      position: 'relative',
      display: 'inline-block',
      marginLeft: "15px",
  
    },
    posidaustria: {
      position: 'absolute',
      display: 'inline-block',
      top: "-2px",
      left:"-10px",
    },
    deluser: {
      position: 'absolute',
      display: 'inline-block',
      top: "-8px",
      left:"24px",
      cursor: "pointer",
    },
    posiok: {
      position: 'absolute',
      display: 'inline-block',
      top: "30px",
      left:"-3px",
      backgroundColor: "white",
    },
    screenok: {
      position: 'absolute',
      display: 'inline-block',
      top: "15px",
      left:"-12px",
      backgroundColor: "white",
    },
    scrollpad: {
      margin: '5px',
    },
    guestrow: {
      backgroundColor: "#fcfcfc",
      padding: "5px",
      paddingTop: "5px",
      paddingRight: "15px",
      borderLeft: `1px dotted #868e96`,
    },
    gast: {
      display: 'inline-block', /* Allow for rotation */
      textAlign: 'center',
      transform: 'rotate(90deg)',
      paddingRight: "20px",
    },
    
  }));



export function ShowUserOnline() {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const meetinginfo = useSelector((state: any) => state.user.meetinginfo)
    const initparticipants = useSelector((state: any) => state.user.meetinguser)
    const screenshots = useSelector((state: any) => state.user.identscreenshots)

    const [opened, setopenAddGuest] = useState(false);
    const [deletopened, setDeletopened] = useState(false);

    const [email, setEmail] = useState('');   
    const [isValidemail, setIsValidemail] = useState(true);
    const [deleteemail, setdeleteemail] = useState("");


    const [sendreminderopened, setSendreminderopened] = useState(false);
    const [sendreminderall, setSendreminderall] = useState(true);
    

    //console.log(email)
    //console.log(isValidemail)


    useEffect(() => {
      
      if (email !== "") {
          setIsValidemail(validateEmail(email));
      }
    }, [email]);

    useEffect(() => {
      if (deleteemail !== "") {
        removeguest() 
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deleteemail]);


    const setopenAddGuestDrn = () => {
      dispatch({ type: 'SIGNALR_GETADDUSER_FROMDRN'});
      setopenAddGuest(true)
    }


  

    const handleSendYesClick = () => {
      let sendmaildata
     // console.log(sendreminderall)
      if (sendreminderall){
        sendmaildata = initparticipants.filter((obj: { role: any; meetingParticipantStatus: string; }) => {
        return obj.role !== "notar" 
      });
      } else {
        sendmaildata = initparticipants.filter((obj: { role: any; meetingParticipantStatus: string; }) => {
          return obj.role !== "notar" && (obj.meetingParticipantStatus === "LeftMeeting" || obj.meetingParticipantStatus === null)
      });
    }

    const participantIds = sendmaildata.map((item:any) => {
      return item.id; // Access Guid of Participant
    });

    const mailreminderpayload = {
      drnId: meetinginfo.drnId,
      participantIds: participantIds
        
    }; 
      console.log(mailreminderpayload)
      dispatch({ type: 'SIGNALR_REINVITEGUESTFROMVK', payload: mailreminderpayload });
      setSendreminderopened(false)
    }
   

    const handleSendNoClick = () => {
      setSendreminderopened(false)
    }
   



    // Schliesst das EIngabe Fenster für die Invite Mail Adresse
    const handlecloseAddUser = () => {
        setopenAddGuest(false)
        setEmail('')
        setIsValidemail(true)
    }

    const handlecloseDeleteUser = () => {
      setDeletopened(false)
  }

    const validateEmail = (email: string): boolean => {
      // Regular expression for email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };


    // Funktion um einen Gastuser via DRN einzuladen
    // drnId: Id der Videokonferenz
    // GuestEmail: E-Mail Adresse des Gastusers
    const sentguestinvite = () => {
      /*const addguestpayload = {
        drnId: meetinginfo.drnId,
        GuestEmail: email
          
      }; 
      console.log(addguestpayload)
      
       dispatch({ type: 'SIGNALR_INVITEGUESTFROMVK', payload: addguestpayload });
       setEmail('');*/
       handlecloseAddUser()
      } 


    // Funktion um einen Gastuser aus der VK zu entfernen
    // drnId: Id der Videokonferenz
    // GuestEmail: E-Mail Adresse des Gastusers
      const removeguest = () => {
        const removeguestpayload = {
          drnId: meetinginfo.drnId,
          GuestEmail: deleteemail
            
        }; 
        console.log(removeguestpayload)
        
         dispatch({ type: 'SIGNALR_REMOVEGUESTFROMVK', payload: removeguestpayload });
         setdeleteemail('');
         handlecloseDeleteUser()
        } 



   

    const onlinedata = initparticipants.filter((obj: { role: any; meetingParticipantStatus: string; }) => {
        return (obj.role !== "notar" && obj.role !== "gast") && obj.meetingParticipantStatus === "InMeeting"
    });

    const offlinedata = initparticipants.filter((obj: { role: any; meetingParticipantStatus: string; }) => {
        return (obj.role !== "notar" && obj.role !== "gast") && (obj.meetingParticipantStatus === "LeftMeeting" || obj.meetingParticipantStatus === null)
    });

    const notardata = initparticipants.filter((obj: { role: any; meetingParticipantStatus: string; }) => {
        return obj.role === "notar" 
    });

    const guestdata = initparticipants.filter((obj: { role: any; meetingParticipantStatus: string; }) => {
        return obj.role === "gast" 
    });

    const notarrows = (notardata || []).map((item:any, index:any) => {

        let a = item.lastName.substring(0,1)
        let b = item.firstName.substring(0,1)
        let initialen = a + b
        let fullname = item.lastName + " " + item.firstName

       let inmeetingcolor = "red"
       if (item.meetingParticipantStatus === null) {
         inmeetingcolor = "red"
       }
       if (item.meetingParticipantStatus === "LeftMeeting") {
         inmeetingcolor = "red"
       }
       if (item.meetingParticipantStatus === "InMeeting") {
         inmeetingcolor = "green"
       }

       return (
        <div className={classes.overdiv} key={index}>
        <Tooltip label={fullname}>
        <Indicator inline size={12} offset={4} position="bottom-end" color={inmeetingcolor} withBorder>
           <Avatar  alt={fullname} variant="outline" color={inmeetingcolor}   radius="xl" size="md" >
             {initialen} 
          </Avatar> 
      </Indicator>
      </Tooltip>
      </div>
       )
    })

    const offlinerows = (offlinedata || []).map((item:any, index:any) => {

        let a = item.lastName.substring(0,1)
        let b = item.firstName.substring(0,1)
        let initialen = a + b
        let fullname = item.lastName + " " + item.firstName

       let inmeetingcolor = "red"
       if (item.meetingParticipantStatus === null) {
         inmeetingcolor = "red"
       }
       if (item.meetingParticipantStatus === "LeftMeeting") {
         inmeetingcolor = "red"
       }
       if (item.meetingParticipantStatus === "InMeeting") {
         inmeetingcolor = "green"
       }

       return (
        <div className={classes.overdiv} key={index + 100}>
        <Tooltip label={fullname}>
        <Indicator inline size={12} offset={4} position="bottom-end" color={inmeetingcolor} withBorder>
           <Avatar  alt={fullname} variant="outline" color="dark"  radius="xl" size="md" >
             {initialen} 
          </Avatar> 
      </Indicator>
      </Tooltip>
      </div>
       )
    })

    const onlinerows = (onlinedata || []).map((item:any, index:any) => {

        let a = item.lastName.substring(0,1)
        let b = item.firstName.substring(0,1)
        let initialen = a + b
        let fullname = item.lastName + " " + item.firstName

       let inmeetingcolor = "red"
       if (item.meetingParticipantStatus === null) {
         inmeetingcolor = "red"
       }
       if (item.meetingParticipantStatus === "LeftMeeting") {
         inmeetingcolor = "red"
       }
       if (item.meetingParticipantStatus === "InMeeting") {
         inmeetingcolor = "green"
       }

       let idaustriaident
       if (item.idAustriaData !== null) {
        idaustriaident = item.idAustriaData.isIdentified
       }

       let showscreenicon = false  
       const havescreendata = screenshots.filter((obj: { userParticipantId: any }) => {
           return obj.userParticipantId === item.id 
       });
     
       if (havescreendata.length > 0) {
         showscreenicon = true
       }


       const confirmedonefilter = item.actions.filter((obj: { scenarioId: any; }) => {
        return obj.scenarioId === item.actions[0].scenarioId
        });

      let confirm = confirmedonefilter[0].isDone

    return (
      <div className={classes.overdiv} key={index + 200}>
        <Tooltip label={fullname}>
        <Indicator inline size={12} offset={4} position="bottom-end" color={inmeetingcolor} withBorder>
            <Avatar  alt={fullname} variant="outline" color={inmeetingcolor}   radius="xl" size="md" >
                {initialen} 
            </Avatar> 
        </Indicator>
       
        </Tooltip>
        {idaustriaident && idaustriaident !== undefined &&
          <Image
                  height={15}
                  width={31}
                    src={idaustrialogo}
                    className={classes.posidaustria}
                    />
          }
          {confirm && 
             <span>
                   <Checkbox size={14} strokeWidth={1} color="green" className={classes.posiok} />
            </span>
          }

          {showscreenicon && 
            <span>
              <DeviceComputerCamera size={14} strokeWidth={1} color="green" className={classes.screenok} />
            </span>
          } 
      </div>
       )
    })


    const guestrows = (guestdata || []).map((item:any, index:any) => {

      //let a = item.lastName.substring(0,1)
      //let b = item.firstName.substring(0,1)
      //let initialen = "GU"
      let fullname = item.emailAddress

      const [username, domain] = item.emailAddress.split('@')[0]
      const initials = username[0].toUpperCase() + domain[0].toUpperCase();

     let inmeetingcolor = "red"
     if (item.meetingParticipantStatus === null) {
       inmeetingcolor = "red"
     }
     if (item.meetingParticipantStatus === "LeftMeeting") {
       inmeetingcolor = "red"
     }
     if (item.meetingParticipantStatus === "InMeeting") {
       inmeetingcolor = "green"
     }

     return (
      <div className={classes.overdiv} key={index + 400}>
      <Tooltip label={fullname}>
      <Indicator inline size={12} offset={4} position="bottom-end" color={inmeetingcolor} withBorder>
         <Avatar  alt={initials} variant="outline"  radius="xl" size="md" >
           {initials} 
        </Avatar> 
    </Indicator>
    </Tooltip>
            <span onClick={() => setdeleteemail(item.emailAddress)}>
                   <CircleX  size={18} strokeWidth={2}  className={classes.deluser} />
            </span>
    </div>
     )
  })


  return (
    <>
    <Grid className={classes.padtop10}>
    <Grid.Col xs={10} sm={10} md={10} >
        <Group spacing="xs">
          {notarrows} 
          {onlinerows}  
          {offlinerows} 
          {guestrows.length !== 0 &&
          <div className={classes.guestrow}>
            <div className={classes.gast}>Gast</div>
            {guestrows}</div>
          }
          </Group>
      </Grid.Col>
    <Grid.Col xs={2} sm={2} md={2}> <Group position="right" className={classes.padtop10}>
    <Tooltip label={intl.get('TOOLSVIEW_GUESTREMINDER_BUTTON')} multiline={true}><span>< MailForward size={24} strokeWidth={1} onClick={() => setSendreminderopened(true)}/></span></Tooltip>
     <Tooltip label={intl.get('TOOLSVIEW_ADDGUEST_BUTTON')} multiline={true}><span>< UserPlus size={24} strokeWidth={1} onClick={() => setopenAddGuestDrn()}/></span></Tooltip>
       <Tooltip label={intl.get('TOOLSVIEW_SHOWONLINE_OFF')} multiline={true}><span>< UserOff size={24} strokeWidth={1} onClick={() => dispatch(handleonlinebar(false))}/></span></Tooltip>
      </Group>
      </Grid.Col>
    </Grid>

    <Modal
        title={intl.get('TOOLSVIEW_ADDGUEST_BUTTON')}
        opened={opened}
        onClose={handlecloseAddUser}
        closeOnClickOutside={false}
        withCloseButton={true}
        size="80%"
        shadow="sm"
        centered
        zIndex={10000}
        >
          <AddUserToMeetingDrn />
          {/*}
          <Text>{intl.get('TOOLSVIEW_ADDGUEST_INFO')} </Text>
         
            <Grid.Col span={12}>
            <TextInput placeholder="E-Mail Adresse" value={email} onChange={(event) => setEmail(event.currentTarget.value)} {...(!isValidemail && { error: 'Korrekte E-Mail Adresse erwartet' })}   />

            </Grid.Col>
            */}
             <hr />
            <Grid>
            <Grid.Col span={12}>
            <Button fullWidth color="gray" variant="light" onClick={sentguestinvite}>{intl.get('ADDUSER_MODAL_CLOSE')}</Button>
            </Grid.Col>
          </Grid>
          
      </Modal> 

      <Modal
        title=""
        opened={deletopened}
        onClose={handlecloseDeleteUser}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="md"
        shadow="sm"
        centered
        >
          <Text>{intl.get('TOOLSVIEW_REMOVEGUEST_INFO')}</Text>
          <hr />
          <Grid>
          <Grid.Col span={6}>
            <Button fullWidth color="green" onClick={removeguest} >{intl.get('SETUP_MEETING_MODAL_DOCHAVESIGNS_YES')}</Button>
            </Grid.Col>
            <Grid.Col span={6}>
            <Button fullWidth color="red" onClick={handlecloseDeleteUser}  variant="light">{intl.get('SETUP_MEETING_MODAL_DOCHAVESIGNS_NO')}</Button>
            </Grid.Col>
          </Grid>
      </Modal> 

      <Modal
        title=""
        opened={sendreminderopened}
        onClose={handleSendNoClick}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="400"
        shadow="sm"
        centered
        zIndex={10000}
        >
          <Text>{intl.get('TOOLSVIEW_REINVITE_INFO')} </Text> 
          <Alert  color="gray">
            <Switch size="md" color="green" label={intl.get('TOOLSVIEW_REINVITE_LABLE')} onLabel="Alle" offLabel="Offline"   checked={sendreminderall}  onChange={() => setSendreminderall(!sendreminderall)} /> 
         </Alert>
          
          <hr />
          
          <Grid>
          <Grid.Col span={6}>
            <Button fullWidth color="green" onClick={handleSendYesClick}>{intl.get('DIALOG_BUTTON_YES')}</Button>
            </Grid.Col>
            <Grid.Col span={6}>
            <Button fullWidth color="gray" variant="light" onClick={handleSendNoClick}>{intl.get('DIALOG_BUTTON_NO_CLOSE')}</Button>
            </Grid.Col>
          </Grid>
         
      </Modal> 
    </>
  );
}